<app-image-section-head [title]="title" [description]="description" [image]="image"></app-image-section-head>

<main id="main-content" class="container my-5">
    <div class="row">
        <div class="col text-center">
            <div class="accordion secondary" id="accordion_faq">
                @for (block of blocks; track block.title) {
                    <div class="block">
                        <h2 class="text-left">{{block.title}}</h2>
                        @for (question of block.questions; track question.id) {
                        <div class="accordion-item" [id]="'question-'+question.id">
                            <h2 class="accordion-header">
                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    [attr.data-bs-target]="'#collapse-' + question.id" aria-expanded="false"
                                    [attr.aria-controls]="'collapse-' + question.id" [innerHTML]="question.question" (click)="scrollTo(question.id)"></button>
                            </h2>
                            <div id="collapse-{{question.id}}" class="accordion-collapse collapse"
                                data-bs-parent="#accordion_faq">
                                <div class="accordion-body" [innerHTML]="question.answer"></div>
                            </div>
                        </div>
                        }
                    </div>
                }
            </div>
        </div>
    </div>
</main>